import { FC, MouseEvent } from 'react';

import '@pathofdev/react-tag-input/build/index.css';
import ReactTagInput from '@pathofdev/react-tag-input';
import cx from 'classnames';

import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';

import RadioButton from '../../FormAdapters/FormDefault/RadioButton';
import RadioGroup from '../../FormAdapters/FormDefault/RadioButton/Group';
import Icon from '../../Icon';
import Close from '../../Icon/icons/Close';
import Loader from '../../Loader';
import { IBaseSearchFilterFormProps } from '../types';
import { useBaseSearchFilterForm } from './functions';
import s from './index.module.css';

const SEARCH_FILTER_SHOW_STATUS = {
  ALL: 'all',
  MY: 'my',
  SP: 'sp',
  SHARED: 'shared',
};

const BaseSearchFilterForm: FC<IBaseSearchFilterFormProps> = ({
  filter,
  defaultFilter,
  showRadioButtons,
  title,
  loading,
  onSave,
  onClose,
  onDelete,
  type = 'content',
}) => {
  const { layout, currentFilter, hasChanges, isDefaultFilter, handleChange, handleSave, handleReset, handleClose } =
    useBaseSearchFilterForm({
      filter,
      defaultFilter,
      onSave,
      onClose,
      type,
    });

  const { show, tags } = currentFilter.data;

  const onDeleteFilter = (e: MouseEvent<HTMLElement>) => {
    /*@ts-ignore*/
    onDelete(e);
    onClose();
  };

  return (
    <div className={s.wrapper}>
      {loading && <Loader isFillBlock />}
      <div className={s.title}>
        <div>{title}</div>
        <Icon component={Close} strokeWidth={1.5} className={s.crossIcon} onClick={handleClose} />
      </div>
      {/* @ts-ignore */}
      <div className={cx(s.body, s[layout.radio])}>
        {showRadioButtons && (
          /*@ts-ignore*/
          <RadioGroup name="show" isVertical value={show} onChange={(value) => handleChange({ show: value })}>
            {/*@ts-ignore*/}
            <RadioButton value={SEARCH_FILTER_SHOW_STATUS.ALL}>Show All {layout.text}</RadioButton>
            {/*@ts-ignore*/}
            <RadioButton value={SEARCH_FILTER_SHOW_STATUS.MY}>Show only My {layout.text}</RadioButton>
            {/*@ts-ignore*/}
            <RadioButton value={SEARCH_FILTER_SHOW_STATUS.SP}>Show only Safari Portal {layout.text}</RadioButton>
            {/*@ts-ignore*/}
            <RadioButton value={SEARCH_FILTER_SHOW_STATUS.SHARED}>Show only Shared {layout.text}</RadioButton>
          </RadioGroup>
        )}

        <div className={s.keywords}>Keywords</div>

        <ReactTagInput
          placeholder="Type keyword and press Enter"
          tags={tags}
          onChange={(newTags) => handleChange({ tags: newTags })}
        />
      </div>

      <FormActions isSpaceBetween className={s.buttonsWrapper}>
        {onDelete && !isDefaultFilter && (
          <Button className={s.button} type="default" onClick={(e) => onDeleteFilter(e)}>
            Clear filters
          </Button>
        )}
        <div className={s.buttons}>
          <Button type="default" className={s.button} onClick={handleReset} disabled={isDefaultFilter}>
            Reset
          </Button>
          {/*@ts-ignore*/}
          <Button type={layout.button} className={s.button} onClick={handleSave} disabled={!hasChanges}>
            Save
          </Button>
        </div>
      </FormActions>
    </div>
  );
};

export default BaseSearchFilterForm;
